import React, { useState } from 'react';
import { TABS } from './constants';

function DeviceDetailsTabs({ activeTab, onTabClick, hasSpecialPerms = false }) {
    const [isTabsOpen, setTabsOpen] = useState(false);

    const visibleTabs = TABS.filter(t => {
        if (t.hidden) return false;
        if (t.requiresSpecialPerms && !hasSpecialPerms) return false;
        return true;
    });

    // Desktop: Dynamically split tabs into rows
    const rows = [];
    const chunkSize = 4;
    for (let i = 0; i < visibleTabs.length; i += chunkSize) {
        rows.push(visibleTabs.slice(i, i + chunkSize));
    }

    const handleTabSelect = (tabId) => {
        onTabClick(tabId);
        setTabsOpen(false); // Close dropdown on selection
    };

    return (
        <>
            <style>{`
                .modal-tabs-desktop { display: flex; flex-direction: column; gap: 5px; margin-bottom: 15px; }
                .tab-row { display: flex; gap: 5px; }
                .tab-row button { flex: 1; padding: 10px 5px; border: 1px solid #444; background-color: #2c2c2c; color: #ccc; cursor: pointer; font-size: 14px; transition: background-color 0.2s, color 0.2s, border-color 0.2s; border-radius: 4px; }
                .tab-row button:hover { background-color: #3d3d3d; border-color: #555; }
                .tab-row button.active { background-color: #5a5a9e; color: #fff; font-weight: bold; border-color: #5a5a9e; }
                .modal-tabs-mobile { display: none; } /* Hidden by default */
            `}</style>

            {/* Desktop Tabs */}
            <div className="modal-tabs-desktop">
                {rows.map((row, rowIndex) => (
                    <div className='tab-row' key={rowIndex}>
                        {row.map(tab => (
                            <button
                                key={tab.id}
                                className={activeTab === tab.id ? 'active' : ''}
                                onClick={() => onTabClick(tab.id)}
                            >
                                {tab.label}
                            </button>
                        ))}
                    </div>
                ))}
            </div>

            {/* Mobile Tabs Dropdown */}
            <div className="modal-tabs-mobile">
                <button className="mobile-dropdown-button" onClick={() => setTabsOpen(prev => !prev)}>
                    Навигация {isTabsOpen ? '▲' : '▼'}
                </button>
                {isTabsOpen && (
                    <div className="mobile-dropdown-content tabs">
                        <div className="tabs-grid-container">
                            {visibleTabs.map(tab => (
                                <button
                                    key={tab.id}
                                    className={activeTab === tab.id ? 'active' : ''}
                                    onClick={() => handleTabSelect(tab.id)}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}

export default DeviceDetailsTabs;